export default [
  {
    title: 'breadcrumb.dashboard',
    route: 'home',
    icon: 'BarChart2Icon',
    resource: 'home',
    action: 'read',
  },
];